import { homedir } from "os";
function labelProcess(title) {
  var home = homedir();
  var cwd = process.cwd();
  process.title = `Onejs:${title} > ${cwd.replace(home, "~")}`;
}
export {
  labelProcess
};
//# sourceMappingURL=label-process.js.map
